import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBell: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bell, notification, activity, alert"} maskId="square-filled-radius-0-stroke-1-IconBell"><path d="M11.9998 2C7.81721 2 4.30857 5.1556 3.86665 9.31476L2.94385 18H21.0557L20.1329 9.31477C19.691 5.1556 16.1824 2 11.9998 2Z" fill="currentColor"/><path d="M16.2437 19H7.75585C8.3736 20.7478 10.0405 22 11.9998 22C13.9591 22 15.626 20.7478 16.2437 19Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBell;
